import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

export const TestimonialsColumn = ({ className, testimonials, duration = 10 }) => {
  return (
    <div className={className}>
      <motion.div
        animate={{
          translateY: "-50%",
        }}
        transition={{
          duration: duration,
          repeat: Infinity,
          ease: "linear",
          repeatType: "loop",
        }}
        className="flex flex-col gap-6 pb-6"
      >
        {[
          ...new Array(2).fill(0).map((_, index) => (
            <React.Fragment key={index}>
              {testimonials.map(({ text, image, name, role }, i) => (
                <div 
                  className="p-6 rounded-2xl bg-white/10 backdrop-blur-lg border border-white/20 hover:bg-white/15 transition-all duration-300 hover:scale-[1.02] shadow-xl hover:shadow-purple-500/30 w-[380px] min-h-[280px] flex flex-col" 
                  key={i}
                >
                  {/* Text */}
                  <div className="text-gray-100 text-base leading-relaxed font-light mb-4 flex-grow">
                    "{text}"
                  </div>
                  
                  {/* Stars */}
                  <div className="flex gap-1 mb-4 mt-auto">
                    {[...Array(5)].map((_, starIndex) => (
                      <Star 
                        key={starIndex} 
                        className="w-3 h-3 text-yellow-400 fill-yellow-400 drop-shadow-[0_2px_4px_rgba(251,191,36,0.3)]" 
                      />
                    ))}
                  </div>
                  
                  {/* Author */}
                  <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                    <img
                      width={40}
                      height={40}
                      src={image}
                      alt={name}
                      className="h-10 w-10 rounded-full object-cover ring-2 ring-purple-500/30"
                      loading="lazy"
                    />
                    <div className="flex flex-col">
                      <div className="font-semibold tracking-tight leading-5 text-white text-sm">{name}</div>
                      <div className="leading-5 text-gray-400 tracking-tight text-xs">{role}</div>
                    </div>
                  </div>
                </div>
              ))}
            </React.Fragment>
          )),
        ]}
      </motion.div>
    </div>
  );
};
